import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { provideCssService } from './provideCssService'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(provideCssService)
}

export const editor: ContainerModuleLoader = site
